<section class="site-gateways">
  <iot-platform-ui-panel
    [buttonTooltip]="'SITES.GATEWAYS.ADD' | translate"
    [hasButton]="false"
    [title]="'SITES.GATEWAYS.PANEL_TITLE' | translate"
    [withCustomAction]="true"
    class="mt-4 mb-4"
  >
    <div fxFlexLayout="row" fxLayoutAlign="center center" panelCustomAction>
      @if (gatewaysBySite?.length > 2 || (gatewaysBySite?.length > 1 && hasGateways && canAddGateway)) {
        <div
          [matTooltip]="(horizontalLayout ? 'PANELS.TOOLTIPS.HORIZONTAL_LAYOUT' : 'PANELS.TOOLTIPS.VERTICAL_LAYOUT') | translate"
          class="panel-button app-round-button"
          matTooltipClass="regular-tooltip"
        >
          <button (click)="horizontalLayout = !horizontalLayout" fxHide.lt-md mat-icon-button>
            <mat-icon>{{ horizontalLayout ? 'apps' : 'swap_horiz' }}</mat-icon>
          </button>
        </div>
      }
      @if (!loading && canUpdateSite && canAddGateway && hasGateways) {
        <div [matTooltip]="'SITES.GATEWAYS.ADD' | translate" class="panel-button app-round-button" matTooltipClass="regular-tooltip">
          <ng-container *ngTemplateOutlet="gatewaysContextMenu"></ng-container>
        </div>
      }
      @if (canUpdateSite) {
        <div
          [matTooltip]="'SITES.GATEWAYS.SYNCHRONIZE' | translate"
          [ngClass]="{ 'app-round-button--rotate': loading }"
          class="panel-button app-round-button site-gateways__btn-sync"
          matTooltipClass="regular-tooltip"
        >
          <button (click)="onSyncGateways()" mat-icon-button>
            <mat-icon>sync</mat-icon>
          </button>
        </div>
      }
    </div>

    @if (loading) {
      <div fxFlexLayout="row" fxLayoutAlign="center center" panelGrid style="width: 100%">
        <mat-progress-spinner [diameter]="50" color="accent" mode="indeterminate"></mat-progress-spinner>
      </div>
    } @else if (!hasAssignedGateways && !hasGateways) {
      <ng-container panelGrid>
        <div class="no-data-message" fxFlexAlign="center center" fxFlexLayout="row">
          <p>{{ 'SITES.GATEWAYS.NO_GATEWAYS' | translate }}</p>
        </div>
      </ng-container>
    } @else {
      <iot-platform-ui-cards-container [horizontalLayout]="horizontalLayout" panelGrid>
        @for (gateway of gatewaysBySite; track gateway.id) {
          <oyan-ui-gateway-card
            (dispatchEvent)="onDispatchEvent($event)"
            [element]="gateway"
            [withMenu]="canUpdateSite && canDeleteGateway"
            class="card-md"
            cssClasses="bg-accent"
            fxFlex.lt-md="100%"
            icon="gateway"
          ></oyan-ui-gateway-card>
        }
        @if (canUpdateSite && canAddGateway && hasGateways) {
          <iot-platform-ui-default-card
            [backgroundClass]="'h-100'"
            [title]="'SITES.GATEWAYS.ADD' | translate"
            [withCustomButton]="true"
            [icon]="'add'"
            class="card-md"
            fxFlex.lt-md="100%"
          >
            <ng-container *ngTemplateOutlet="gatewaysContextMenu" cardCustomButton></ng-container>
          </iot-platform-ui-default-card>
        }
      </iot-platform-ui-cards-container>
    }
  </iot-platform-ui-panel>
</section>

<ng-template #gatewaysContextMenu>
  @if (hasGateways) {
    <oyan-ui-mat-menu-list
      (clear)="onClearFilter()"
      (search)="onApplyFilter($event)"
      (selectItem)="onAddGateway($event)"
      [data]="filteredGateways$ | async"
      displayKey="name"
      noDataMessage="SITES.GATEWAYS.NO_GATEWAYS"
      placeholder="SITES.GATEWAYS.FILTER_GATEWAYS"
    ></oyan-ui-mat-menu-list>
  }
</ng-template>
